export default {
    getStartUpDataFromInCache(state) {
        console.log("state.startUpDataDetails",state.startUpDataDetails)
        return state.startUpDataDetails;
    }
};
